<template>
  <div>
    <!--<ag-charts style="height: 300px" :options="processtree"></ag-charts>-->
    <ag-loading v-if="loading" />
    <div class="single-process" v-for="(item, key) in processTree" :key="key">
      <p>
        <b>{{$t("commandLine")}}:</b>
        {{ item.CommandLine }}
      </p>
      <p><b>{{$t("path")}}: </b> {{ item.Path }}</p>
      <p>
        <b>Parent Process ID: </b> {{ item.ParentPID }},
        <b>Creator Process ID: </b> {{ item.creatorPid }}
      </p>
      <hr />
    </div>
    <div v-if="!processTree && !loading" class="no-data-center">No Data</div>

  </div>
</template>

<script>
//import AgCharts from "@/components/ag-charts";
//import { JSONView } from 'vue-json-component';
import { useStore } from "@/store";
const store = useStore();
import api from "@/store/axiosAgsc";
import AgLoading from "@/components/ag-loading/index.vue";

export default {
  name: "ag-processtree",
  /*components: { AgCharts, 'json-view': JSONView },*/
  data() {
    return {
      processTree: [],
      loading: true,
      processtree: {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        top: "1%",
        left: "7%",
        bottom: "1%",
        right: "20%",
        series: [
          {
            type: "tree",

            data: [
              {
                name: "Company 1",
                children: [
                  {
                    name: "Bona Vista",
                    children: [
                      {
                        name: "Discovery Workstation",
                        children: [
                          { name: "STIIN17D03", value: 3938 },
                          { name: "STIIN19D05", value: 3812 },
                          { name: "STIIN18D01", value: 6714 },
                        ],
                      },
                      {
                        name: "Production Workstation",
                        children: [
                          { name: "STIIN17D03", value: 3534 },
                          { name: "BVI31", value: 5731 },
                        ],
                      },
                      {
                        name: "Production Servers",
                        children: [
                          { name: "STIIN17D03", value: 3534 },
                          { name: "BVI31", value: 5731 },
                        ],
                      },
                    ],
                  },
                  {
                    name: "Brad Kage",
                    children: [
                      {
                        name: "Staging",
                        children: [
                          { name: "MFLDC17", value: 1983 },
                          { name: "DSRIN17L05", value: 2047 },
                        ],
                      },
                      {
                        name: "Production Workstation",
                        children: [
                          { name: "STIIN17D03", value: 3534 },
                          { name: "BVI31", value: 5731 },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],

            symbolSize: 7,

            label: {
              position: "left",
              verticalAlign: "middle",
              align: "right",
              fontSize: 9,
            },

            leaves: {
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left",
              },
            },

            emphasis: {
              focus: "descendant",
            },

            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750,
          },
        ],
      },
    };
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      api
        .get(`Event/GetProcessTreeDetail?eventId=${this.selectedRow.evenId}`)
        .then((res) => {
          this.processTree = res.data.entityData;
          this.loading = false;
        });
    },
  },
  components: {
    AgLoading,
  },
};
</script>
<style lang="scss">
.single-process {
  margin-left: 20px;
  position: relative;
  word-break: break-word;
  &::before {
    content: "";
    width: 7px;
    height: 116px;
    position: absolute;
    background-color: #af4242;
    left: -11px;
    top: 0px;
  }
}
</style>
